// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"kT","header":"kU","description":"kV","cta":"kW"};